import { render, staticRenderFns } from "./BaseListContainer.vue?vue&type=template&id=16bd1654"
import script from "./BaseListContainer.vue?vue&type=script&lang=ts"
export * from "./BaseListContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports